// assets/new-arrival.js

(function() {
  'use strict';

  // Strict email validation function - rejects emails without TLD
  function isValidEmail(email) {
    // This regex requires: local@domain.tld
    // Must have at least 2 characters after the last dot
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  }

  function initNewsletterForm() {
    const form = document.querySelector('#launch-subscriber-form');
    if (!form) return;
    
    const emailInput = form.querySelector('#newsletter-email');
    const submitBtn = form.querySelector('.button');
    
    // Create error message span dynamically below the field
    const errorSpan = document.createElement('span');
    errorSpan.className = 'newsletter-error';
    // errorSpan.style.cssText = 'color: #ff0000; font-size: 14px; margin-top: 8px; display: none;';
    if (emailInput && emailInput.parentNode) {
      emailInput.parentNode.insertBefore(errorSpan, emailInput.nextSibling);
    }
    
    if (emailInput) {
      emailInput.addEventListener('input', function() {
        const emailValue = this.value.trim();
        
        // Hide error if empty
        if (emailValue === '') {
          errorSpan.style.display = 'none';
          errorSpan.textContent = '';
          return;
        }
        
        // Real-time validation
        if (!isValidEmail(emailValue)) {
          errorSpan.textContent = 'Please enter a valid email address (e.g., name@domain.com)';
          errorSpan.style.display = 'block';
        } else {
          errorSpan.style.display = 'none';
          errorSpan.textContent = '';
        }
      });
      
      // Add blur event to validate when user leaves the field
      emailInput.addEventListener('blur', function() {
        const emailValue = this.value.trim();
        
        if (emailValue === '') {
          errorSpan.style.display = 'none';
          errorSpan.textContent = '';
          return;
        }
        
        if (!isValidEmail(emailValue)) {
          errorSpan.textContent = 'Please enter a valid email address (e.g., name@domain.com)';
          errorSpan.style.display = 'block';
        }
      });
      
      // Add focus event to show validation if there was an error
      emailInput.addEventListener('focus', function() {
        const emailValue = this.value.trim();
        
        if (emailValue !== '' && !isValidEmail(emailValue)) {
          errorSpan.textContent = 'Please enter a valid email address (e.g., name@domain.com)';
          errorSpan.style.display = 'block';
        }
      });
    }
    
    form.addEventListener('submit', function(e) {
      const successEl = form.querySelector('.newsletter-success');
      
      // Hide success message on new submission
      if (successEl) successEl.style.display = 'none';
      
      if (!emailInput) {
        e.preventDefault();
        return;
      }
      
      const emailValue = emailInput.value.trim();
      
      // Check if email is empty
      if (emailValue === '') {
        e.preventDefault();
        errorSpan.textContent = 'Email address is required';
        errorSpan.style.display = 'block';
        return;
      }
      
      // Strict email validation - will reject john@gmail
      if (!isValidEmail(emailValue)) {
        e.preventDefault();
        errorSpan.textContent = 'Please enter a valid email address (e.g., name@domain.com)';
        errorSpan.style.display = 'block';
        return;
      }
      
      // If validation passes, show success state
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Submitting...';
      }
    });
    
    window.addEventListener('load', function() {
      const successEl = form.querySelector('.newsletter-success');
      
      if (submitBtn) {
        const buttonText = form.dataset.buttonText || 'Get Launch Updates';
        
        if (successEl && successEl.style.display !== 'none') {
          submitBtn.textContent = buttonText;
          submitBtn.disabled = false;
          if (emailInput) emailInput.value = '';
          errorSpan.style.display = 'none';
          errorSpan.textContent = '';
        }
        
        if (errorSpan.style.display !== 'none') {
          submitBtn.textContent = buttonText;
          submitBtn.disabled = false;
        }
      }
    });
  }

  // Initialize when DOM is ready
  function initialize() {
    initNewsletterForm();
  }

  // Handle Shopify section reload (for theme editor)
  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function(event) {
      if (event.target && event.target.querySelector('#launch-subscriber-form')) {
        setTimeout(initNewsletterForm, 100);
      }
    });
    
    document.addEventListener('shopify:section:reorder', function(event) {
      if (event.target && event.target.querySelector('#launch-subscriber-form')) {
        setTimeout(initNewsletterForm, 100);
      }
    });
  }

  // Listen for section updates via AJAX
  document.addEventListener('shopify:section:load', function(event) {
    const section = event.detail ? event.detail.section : null;
    if (section && section.querySelector && section.querySelector('#launch-subscriber-form')) {
      setTimeout(initNewsletterForm, 100);
    }
  });

  // Fallback: initialize when DOM is fully loaded
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize);
  } else {
    initialize();
  }
})();